<template>
  <div v-cloak class="hello">
    <!-- 第二行-->
    <div class="header-second">
      <div class="container flex f-between height100 ">
        <div class="img-logo flex f-center">
          <img src="../img/logo.png" alt="" @click="toPage" />
        </div>
        <div class="flex c-fff f-between width80 ma-l-40">
          <div
            v-for="(item, indexs) in titles"
            :key="indexs"
            class="c-p first-menu flex1 t-center"
            @click="toggle(item.path)"

          >
            {{ item.name }}
            <!-- 二级菜单 -->
            <div class="submenu">
              <div v-for="(item2,index2) in item.children" :key="index2" class=""  @click="toggle(item2.path)">{{ item2.name }}</div>
            </div>
          </div>
          <div class="c-p first-menu t-center">
              <span v-if="isLogin" class="c-p pa-l-10 flex f-center">
                <span  @click="toggle('/user/index')" class="pa-r-10">会员中心(<span class="">{{ names }}</span>)</span>
                <span class="split-line"></span>
                <span @click="quit()" class="pa-l-10">退出登录</span>
              </span>
              <span v-if="!isLogin" class="c-p pa-l-10 flex f-center">
                <span @click="login()" class="pa-lr-10">登录</span> 
                <span class="split-line"></span>
                <span @click="register"  class="pa-l-10">注册</span>
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quitlogin, getuser } from "../api.js";
import "element-ui/lib/theme-chalk/display.css";
import heardTitles from "../assets/heardTitles.js";
export default {
  name: "Heard",
  props: {
    msg: String,
  },
  data() {
    return {
      ismenu: false,
      titles: heardTitles,
      input2: "",
      path:'/about/cuilin',
      names: "登录", //用户姓名
      isLogin: "", //shifou登录
      loginstatus: "", //是否登录
    };
  },
  created() {
    let token = localStorage.getItem("AccessToken") || "";
    this.path = this.$route.path;
    // token ? (this.loginstatus = true) : (this.loginstatus = false);
    if (token) {
      getuser({ token: token }).then((res) => {
        this.names = res.data.Data.Name;
      });
      this.isLogin = true;
    } else {
      this.isLogin = false;
      this.names = "";
    }
  },
  filters: {
    sn(e) {
      if (e) {
        return e.length > 4 ? e.slice(0, 4) + "..." : e;
      } else {
        return e;
      }
    },
  },

  watch: {
    $route(to) {
      this.path = this.$route.path;
      if (to.path == "/login" || to.path == "/register" || to.path == "/Find") {
        let token = localStorage.getItem("AccessToken") || "";

        if (token) {
          this.isLogin = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Name;
          });
        } else {
          this.isLogin = false;
          this.names = "登录";
        }
      } else {
        let token = localStorage.getItem("AccessToken");

        if (token) {
          this.isLogin = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Name;
          });
        } else {
          this.isLogin = false;
        }
      }
    },
  },

  methods: {
    //一级菜单移入
    firstMenuEnter(e){
      // console.log(e)
      var dom=e.target.querySelector('.submenu')
      dom.style.display='block'
      dom.classList.add('active-menu')
    },
    //一级菜单移出
    firstMenuOut(e){
      var dom=e.target.querySelector('.submenu')
      dom.classList.remove('active-menu')
      setTimeout(() => {
        dom.style.display='none'
      }, 300);
    },
    //顶部菜单显隐藏
    tiggerMenu() {
      this.ismenu = this.ismenu ? false : true;
    },
    toPage() {
      this.$router.push({ path: "/" });
    },
    toggle(path1) {
      this.ismenu = false;
      this.path1 = path1;
      // this.$router.push(`${path}`);
      if (path1) {
        window.open(path1, "_blank");
      }

      // 隐藏导航栏
      //this.tiggerMenu()
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$router.push("/login");
      } else {
        this.$router.push("/user/index");
      }
    },
    register() {
      this.$router.push("/register");
    },

    quit() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        Source: "web",
        Token: token,
      };

      this.$confirm("您确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        quitlogin(datas).then((res) => {
          if (res.data.Code == 0) {
            localStorage.removeItem("AccessToken");
            localStorage.removeItem("RefreshToken");
            localStorage.removeItem("username");
            localStorage.removeItem("AccessTokenTime");
            localStorage.removeItem("RefreshTokenTime");
            localStorage.removeItem("videostatus");
            localStorage.removeItem("ppttoken");
            this.names = "登录";
            this.loginstatus = false;
            this.$message({
              message: "退出登录成功",
              type: "success",
            });
            setTimeout(() => {
              //退出登录后刷新当前页面
              this.$router.go(0);
            }, 500);
          }
        });
      });
    },
  },
  computed:{
    currentTime(){
      var date=new Date()
      return date.getFullYear()+'年'+(date.getMonth()+1)+'月'+date.getDate()+'日'
    }
  }
};
</script>


<style lang="scss" scoped>
.first-menu{
  position: relative;
  .submenu{
    position: absolute;
    width: 100%;
    z-index: 10;
    line-height: 40px;
    text-align: center;
    background: #fb004b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .3s;
    font-weight: normal;
    div{
      
    padding:5px 0;
    }
  }
  .active-menu{
    max-height: 300px;
  }
}
.first-menu:hover .submenu{
  max-height: 400px;
}
.hello {
  .header-first {
    // min-width: 1200px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    background: #16314e;
    font-size: 12px;
    .media-logo{
      position: relative;
      .media-qrcode{
        width: 200px;
        position:absolute;
        z-index: -10;
        opacity: 0;
        left: -200px;
        top: 0;
        transition: left .3s;
        -webkit-transition:left .3s;
      }
      a{
        text-decoration: none;
        color: #fff;
        font-size: 12px;
      }
    }
    .media-logo:hover .media-qrcode{
       z-index: 3;
       top: 40;
       opacity: 1;
       left: -100px;
    }
  }
  .header-second {
    // min-width: 1200px;
    height: 100px;
    line-height: 100px;
    box-sizing: border-box;
    background: #fb004d;
  }
}
.split-line{
      display:inline-block;
      width: 2px;
      height: 12px;
      background: #fff;
    }
.img-logo {
  width: 180px;
  height: 100%;
  img {
    width: 100%;
  }
}
.actives {
  font-weight: bold;
  border-bottom: 2px solid #fff;
  margin-bottom: 10px;
}
.submenu .actives{
  margin-bottom: 0px;
}
.usernames {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  text-align: right;
}
</style>
